export default "__VITE_ASSET__B3A8k0WL__"